





























































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Activation from '@/ts/windows/Activation';
import TgAdManager from '@/ts/ads/TgAdManager';
import Startup from '@/ts/utils/Startup';
import Store from '@/ts/windows/Store';
import { setTimeout } from 'timers';

let store!: Store;

@Component
export default class App extends Vue {
  private isMenuVisible = false;
  private viewerTheme = 'default';
  private markdownText = '';
  private isDragging: boolean = false;
  private fontSizes = ['x-small', 'small', 'normal', 'large', 'x-large'];
  private fontSize = 'normal';
  private adHtml = '';
  private interstitialAdHtml = '';
  private showAds = true;
  private showInterstitial = false;

  private get isWindows(): boolean {
    return !(window.Windows === undefined);
  }

  private toggleMenu() {
    this.isMenuVisible = !this.isMenuVisible;
  }
  private topClick() {
    this.isMenuVisible = false;
  }

  private setTheme(theme?: string) {
    if (theme !== undefined) {
      this.viewerTheme = theme;
      localStorage.setItem('mv_theme', theme);
    } else {
      const storedTheme = localStorage.getItem('mv_theme');
      this.viewerTheme = storedTheme !== null ? storedTheme : 'default';
    }
  }

  private processFile(file: File) {
    if (file.name.endsWith('.md') || file.name.endsWith('.txt')) {
      const self = this;
      const reader = new FileReader();
      reader.addEventListener('load', () => {
          self.markdownText =  reader.result;
          if (self.$router.currentRoute.name !== 'home') {
            self.$router.push({name: 'home'});
          }
      });
      reader.readAsText(file);
    }
  }

  private fileSelected(input: HTMLInputElement) {
    if (input.files && input.files.length > 0) {
      this.processFile(input.files[0]);
    }
  }

  private openFile() {
    (this.$refs.fileSelector as HTMLInputElement).click();
  }

  private setMarkdownText(text: string) {
    this.markdownText = text;
    this.isMenuVisible = false;
  }

  private dragEnter(event: DragEvent) {
    this.isDragging = true;
  }
  private dragLeave(event: DragEvent) {
    this.isDragging = false;
  }
  private drop(event: DragEvent) {
    this.isDragging = false;
    const files = event.dataTransfer.files;
    if (files && files.length > 0) {
        this.processFile(files[0]);
    }
  }

  private decreaseFont() {
    const index = this.fontSizes.indexOf(this.fontSize);
    if (index > 0) {
      this.setFontSize(this.fontSizes[index - 1]);
    }
  }
  private increaseFont() {
    const index = this.fontSizes.indexOf(this.fontSize);
    if (index < this.fontSizes.length - 1) {
      this.setFontSize(this.fontSizes[index + 1]);
    }
  }
  private setFontSize(size?: string) {
    if (size !== undefined) {
      this.fontSize = size;
      localStorage.setItem('mv_font_size', size);
    } else {
      const storedSize = localStorage.getItem('mv_font_size');
      if (storedSize !== null && this.fontSizes.indexOf(storedSize) > -1) {
        this.fontSize = storedSize;
      } else {
        this.fontSize = 'normal';
      }
    }
  }

  private printDoc() {
    window.print();
  }

  private openTinyGoodies() {
    window.open('https://tinygoodies.com', '_blank');
  }

  private openInMicorosoftStore() {
    window.open('https://www.microsoft.com/store/apps/9PJ021LR0M3G', '_blank');
  }

  private removeAds() {
    this.showAds = false;
    localStorage.setItem('show_ads', 'false');
  }

  private closeInterstitial() {
    this.showInterstitial = false;
  }

  private navigateToRemoveAds() {
    this.showInterstitial = false;
    this.$router.push('remove-ads');
  }

  private async created() {
    Startup.logLaunch();
    this.showAds = Startup.shouldShowAds();
    if (this.showAds && this.isWindows) {
      // check if license was purchased since last launch
      store = new Store();
      if (await store.areAnyAddonsPurchased()) {
        this.removeAds();
      }
    }

    // if on Windows and activated via file association
    Activation.register(this.setMarkdownText);

    if (this.showAds) {
      const adManager = new TgAdManager('tg-markdownview', '250x125');
      adManager.getAd().then((ad) => this.adHtml = ad.html ? ad.html : '');

      const interstitialAdManager = new TgAdManager('tg-markdownview', '1200x900');
      interstitialAdManager.getAd().then((ad) => {
        this.interstitialAdHtml = ad.html ? ad.html : '';

        const launchCount = parseInt(localStorage.getItem('mv_launch_count') || '1', 10);
        if (this.showAds && launchCount > 0 && launchCount % 5 === 0) {
          setTimeout(() => this.showInterstitial = true, 5000);
        }
      });
    }

  }

  private mounted() {
    if (window.document.body.offsetWidth > 768 && this.markdownText === '') {
      this.isMenuVisible = true;
    }

    // handle keyboard events
    window.addEventListener('keydown', (keyEvent) => {
      if (keyEvent.ctrlKey && keyEvent.keyCode === 79 /* o */) {
        keyEvent.preventDefault();
        keyEvent.stopPropagation();
        this.openFile();
      } else if (keyEvent.ctrlKey && keyEvent.keyCode === 80 /* p */) {
        keyEvent.preventDefault();
        keyEvent.stopPropagation();
        this.printDoc();
      } else if (keyEvent.ctrlKey && (keyEvent.keyCode === 107 /* keypad + */ || keyEvent.keyCode === 61 /* + */)) {
        keyEvent.preventDefault();
        keyEvent.stopPropagation();
        this.increaseFont();
      } else if (keyEvent.ctrlKey && (keyEvent.keyCode === 109 /* keypad - */ || keyEvent.keyCode === 173 /* - */)) {
        keyEvent.preventDefault();
        keyEvent.stopPropagation();
        this.decreaseFont();
      }
    });

    this.setFontSize();
    this.setTheme();
  }

}
